<template>
  <div :class="['op--modal-container', {hide: !show}]">
    <div class="op--modal">
      <div class="op--modal-content">
        <div class="loader-box">
          <i class="fas fa-spinner fa-spin fa-3x"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'travellers',
  data () {
    return {
      adults: 1,
      children: 0,
      infants: 0
    }
  },
  computed: {
    show () { return this.$store.state.global.loader.show }
  }
}
</script>

<style lang="scss" scoped>
.op--modal-container{
  overflow: auto;
  -webkit-overflow-scrolling:touch;
}
.op--modal-content{
  text-align: center;
}

.loader-box{
  background-color: #fafafa;
  padding: 30px;
  margin: 0 auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  display: inline-block;
}

</style>



// WEBPACK FOOTER //
// Loader.vue?37783117